// Module
var code = "<div class=\"loading-fill-parent\">\n  <loading class=\"loading\"></loading>\n</div>\n";
// Exports
module.exports = code;